import React, { Component } from 'react';
import { Button, Input, Modal } from 'reactstrap';
import "../css/modal-change-comment-list.scss";

export default class ModalChangeCommentList extends Component {
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  constructor(props) {
    super(props);
    this.state = {
      disabledNoti: false
    };
  }

  handleClick = () => {
    if(this.props.kind === 'disabledNotiComparePage') {
      this.props.disabledNotiComparePage()
    } else if (this.props.kind === 'disabledNotiCompareVersion') {
      this.props.disabledNotiCompareVersion()
    }
  }

  toggle = () => {
    this.props.togglePopup()
  }

  render() {
    const { text, currentAnimation, isOpen } = this.props

    return (
      <Modal
        isOpen={isOpen}
        toggle={() => this.toggle()}
        className="modal-dialog-centered w-fit-content m-auto modal-style"
        modalClassName="modal-second"
        contentClassName="akaire_alert_popup"
      >
        <div className='swal2-html-container text-center'>
          <div className="comment-instruction-modal">
            <div className="comment-instruction-modal-title">メディア画面と異なるバージョンのコメントを表示する</div>

            <div className="comment-instruction-box-wrapper">
              <div className="comment-instruction-box">
                <div className="comment-instruction-content">ここでは、コメントツールを（Ver.{text}）に切り替えることで、</div>
                <div className="comment-instruction-content">メディア画面（Ver.{currentAnimation?.final ? '最終稿' : currentAnimation?.title}）と比較しながら確認できます。</div>
              </div>
            </div>


            <div className="comment-instruction-box-wrapper">
              <div className="dashed-box"></div>
            </div>

            <div className="comment-instruction-box-wrapper">
              <div className="comment-instruction-box">
                <div className="comment-instruction-content">投稿されたコメントが、別のバージョンで修正済みかどうかを確認したい場合に便利です。</div>
                <div className="comment-instruction-content">・メディア画面では（例）Ver.{currentAnimation?.final ? '最終稿' : currentAnimation?.title} を表示</div>
                <div className="comment-instruction-content">・コメントツールでは（例）Ver.{text} を表示</div>
                <div className="comment-instruction-content">にすることで、修正が反映されているか、見比べて確認しやすくなります。</div>

                <div className="comment-instruction-content mt-4">また、コメントツールのバージョンを切り替えている間に、</div>
                <div className="comment-instruction-content">メディア画面に新しいコメントを追加すると、コメントツールのバージョン切り替えが解除されます。</div>
                <div className="comment-instruction-checkbox">
                  <div>
                    <Input type="checkbox" onClick={() => this.handleClick()} className="mr-2 mt-2"/>
                  </div>
                  <div>
                    <label className="mt-1">今後表示させない</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}
